var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { NgZone, OnInit } from '@angular/core';
import { Tracking } from './tracking.service';
export var NavigationPerformanceCategory;
(function (NavigationPerformanceCategory) {
    NavigationPerformanceCategory[NavigationPerformanceCategory["INITIAL_PAGE_LOAD"] = 0] = "INITIAL_PAGE_LOAD";
    NavigationPerformanceCategory[NavigationPerformanceCategory["ROUTE_CHANGE"] = 1] = "ROUTE_CHANGE";
})(NavigationPerformanceCategory || (NavigationPerformanceCategory = {}));
var NavigationPerformanceTrackingComponent = /** @class */ (function () {
    function NavigationPerformanceTrackingComponent(t, config, ngZone) {
        this.t = t;
        this.config = config;
        this.ngZone = ngZone;
    }
    NavigationPerformanceTrackingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.ngZone.runOutsideAngular(function () { return __awaiter(_this, void 0, void 0, function () {
            var previousUrl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Math.random() > this.config.navigationPerformanceSamplingRate) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, import('boomerang/build/boomerang-1.621.custom-1.js')];
                    case 1:
                        _a.sent();
                        // Whenever Boomerang intercepts an XHR request, it will check if that
                        // request matches anything in the exclude list, and if it does, Boomerang
                        // will not instrument, time, or beacon that request
                        BOOMR.xhr_excludes = {
                            't.freelancer.com': true,
                            'googleads.g.doubleclick.net': true,
                            'static.doubleclick.net': true,
                            'www.googletagmanager.com': true,
                            'www.google.com': true,
                            'connect.facebook.net': true,
                        };
                        BOOMR.init({
                            log: function (message, level, source) {
                                if (level === 'error') {
                                    console.error(message, source);
                                }
                            },
                            autorun: false,
                            History: {
                                auto: true,
                                enabled: true,
                            },
                            RT: {
                                cookie: '',
                            },
                        });
                        // boomerang as its own error handling thing
                        BOOMR.plugins.Errors = {
                            is_supported: function () {
                                return true;
                            },
                            is_complete: function () {
                                return true;
                            },
                            send: function (err) {
                                throw err;
                            },
                        };
                        BOOMR.subscribe('before_beacon', function (e) {
                            if (e['http.initiator'] !== 'spa_hard' &&
                                e['http.initiator'] !== 'spa') {
                                return;
                            }
                            // Previous URL
                            if (!previousUrl) {
                                previousUrl = e.r;
                            }
                            var data = {
                                category: e['http.initiator'] !== 'spa'
                                    ? NavigationPerformanceCategory.INITIAL_PAGE_LOAD
                                    : NavigationPerformanceCategory.ROUTE_CHANGE,
                                totalTime: e.t_done,
                                backendTime: e.t_resp,
                                frontendTime: e.t_page,
                                previousUrl: previousUrl,
                                resourceTimings: e.restiming,
                            };
                            // NavigationTimings
                            if (e.nt_nav_st) {
                                Object.assign(data, {
                                    // PerformanceNavigation
                                    redirectCount: e.nt_red_cnt,
                                    navigationType: e.nt_nav_type,
                                    // PerformanceTiming
                                    navigationStart: e.nt_nav_st,
                                    redirectStart: e.nt_red_st,
                                    redirectEnd: e.nt_red_end,
                                    fetchStart: e.nt_fet_st,
                                    domainLookupStart: e.nt_dns_st,
                                    domainLookupEnd: e.nt_dns_end,
                                    connectStart: e.nt_con_st,
                                    connectEnd: e.nt_con_end,
                                    requestStart: e.nt_req_st,
                                    responseStart: e.nt_res_st,
                                    responseEnd: e.nt_res_end,
                                    domLoading: e.nt_domloading,
                                    domInteractive: e.nt_domint,
                                    domContentLoadedEventStart: e.nt_domcontloaded_st,
                                    domContentLoadedEventEnd: e.nt_domcontloaded_end,
                                    domComplete: e.nt_domcomp,
                                    loadEventStart: e.nt_load_st,
                                    loadEventEnd: e.nt_load_end,
                                    unloadEventStart: e.nt_unload_st,
                                    unloadEventEnd: e.nt_unload_end,
                                });
                                if (e.nt_first_paint) {
                                    // First paint
                                    Object.assign(data, {
                                        firstPaint: e.nt_first_paint * 1000,
                                    });
                                }
                            }
                            // Fire the event
                            _this.t.track('page_performance_timings', data);
                            // Clear the Resource Timings Buffer
                            if (window.performance && window.performance.clearResourceTimings) {
                                window.performance.clearResourceTimings();
                            }
                            previousUrl = window.location.href;
                            // Notify boomerang that we've fired the beacon
                            BOOMR.fireEvent('onbeacon', data);
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return NavigationPerformanceTrackingComponent;
}());
export { NavigationPerformanceTrackingComponent };
